import { Clapperboard } from "lucide-react";

export const ReelLoader = ({ label = "Setting the scene..." }) => (
  <div className="flex flex-col items-center justify-center gap-5 py-16" data-testid="reel-loader">
    <div className="relative">
      <Clapperboard className="w-14 h-14 text-[#E50914] reel-spin" />
    </div>
    <p className="font-display text-lg text-white/80 animate-pulse">{label}</p>
  </div>
);
